import { FC } from 'react';

import bootstrapPage, { BootstrapPageProps } from '../HOCs/bootstrapPage';
import MetaHead from '../components/MetaHead';
import Layout from '../components/layouts/Layout';

const privacyCode = `<div name="termly-embed" data-id="38e57d37-2a10-4c15-9b5a-63959c73f9b0" data-type="iframe"></div>
    <script type="text/javascript">(function(d, s, id) {
      var js, tjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s); js.id = id;
      js.src = "https://app.termly.io/embed-policy.min.js";
      tjs.parentNode.insertBefore(js, tjs);
    }(document, 'script', 'termly-jssdk'));</script>
`;

const PrivacyPage: FC<BootstrapPageProps> = () => (
  <>
    <MetaHead 
      title="Privacy | Wave.video"
      description="This page explains how we treat information related to your use of this website and the services offered on and through it, including the personal information you provide while using it."
    />

    <Layout navigationVariant="white" mainVariant="contain">
      <div dangerouslySetInnerHTML={{__html: privacyCode}}>
      </div>
    </Layout>
  </>
);

export default bootstrapPage(PrivacyPage);
